import { LoginForm } from '../auth/components';

const Login = (): React.ReactElement => {
  return <LoginForm></LoginForm>;
};
export default Login;
